import { Component, OnInit, ElementRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as utils from '../../common/utils';
import * as units from '../../common/units';
import * as enums from '../../common/enums';
import * as settings from '../../common/settings';
import * as aspSettings from '../../asp/aspSettings';
import { CreateTrack } from '../../../../app/msg/projMsgs';
import { ZIndexMngr } from '../../common/ZIndexMngr';
import { Point } from '../../common/Point';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { AppInjector } from '../../common/inject';
import { CoordsComponent } from '@core_n/aro/components/coords/coords.component';
import { DynamicsComponent } from '@core_n/aro/components/dynamics/dynamics.component';
import { Animations } from './../../Animations';

@Component({
  templateUrl: './track-creator.component.html',
  styleUrls: ['./../aro.component.scss'],
  animations: [
    Animations.BlinkRedError,
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class TrackCreatorComponent extends ZIndexMngr implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('coords') coords: CoordsComponent;
  @ViewChild('dynamics') dynamics: DynamicsComponent;
  static readonly DIALOG_ID = 'track-creator';

  // Track Type
  public trackType: enums.TrackType = enums.TrackType.ABT;
  public geometry;

  constructor(public dialogRef: MatDialogRef<TrackCreatorComponent>,
    elementRef: ElementRef) {
    super(elementRef);
    this.geometry = aspSettings.savedRClickP;
  }

  static createDialogConfig(top: number, left: number) {
    return utils.createDialogConfig(false, false, TrackCreatorComponent.DIALOG_ID,
      { top: `${top + 10}px`, left: `${left + 10}px` });
  }

  ngOnInit() {
    this.dialogRaise();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    this.dialogClosed();
  }

  // Send CreateTrack
  onSend() {
    let err: boolean = false;
    if (this.coords.checkFormLoc()) {
      err = true;
    }
    if (this.dynamics.checkDynForm()) {
      err = true;
    }

    // stop if there are any errors
    if (err) { return; }

    // Create Track
    let track = new CreateTrack();
    track.TrackType = this.trackType;

    // Get Location
    let geo: Point = this.coords.readFormLoc();
    track.LocationLat = geo.y * units.DEG_TO_RAD;
    track.LocationLong = geo.x * units.DEG_TO_RAD;

    // convert altitude to meters
    let alt: number = parseFloat(this.dynamics.dynForm.value.alt);
    if (this.dynamics.altitudeUnitsNum == settings.DisplayUnits.Imperial) {
      track.LocationAlt = alt * units.FEET_TO_METER;
    }
    else if (this.dynamics.altitudeUnitsNum == settings.DisplayUnits.Metric) {
      track.LocationAlt = alt * 1000;
    }

    // convert speed to m/s if needed
    let spd: number = parseFloat(this.dynamics.dynForm.value.spd);
    if (this.dynamics.speedUnitsNum == settings.DisplayUnits.Imperial) {
      track.VelocityXYZ = spd * units.KNOT_TO_METER_SEC;
    }
    else if (this.dynamics.speedUnitsNum == settings.DisplayUnits.Metric) {
      track.VelocityXYZ = spd * units.KMH_TO_METER_SEC;
    }

    //convert heading to rads
    track.Heading = this.dynamics.dynForm.value.hdg * units.DEG_TO_RAD;

    // special cases
    if (track.TrackType == enums.TrackType.TBM) {
      if (track.VelocityXYZ * units.METER_SEC_TO_KNOT > settings.MISSILE_MAX_SPEED_KNOTS || track.VelocityXYZ * units.METER_SEC_TO_KNOT < settings.MISSILE_MIN_SPEED_KNOTS) {
        this.dynamics.activeErrAnimSpd = true;
        return;
      }
    }
    else {
      if (track.VelocityXYZ > (settings.MAX_SPEED_KNOTS * units.KNOT_TO_METER_SEC)) {
        this.dynamics.activeErrAnimSpd = true;
        return;
      }
    }

    if (this.dynamics.dynForm.value.hdg > 360 || this.dynamics.dynForm.value.hdg < 0) {
      this.dynamics.activeErrAnimHdg = true;
      return;
    }

    AppInjector.get(UserActionService).sendUserAction(track);

    this.dialogClosed();
    this.dialogRef.close();
  }

  checkValueValid(str: string) {
    if (str == undefined || str == null || str == "")
      return false;
    return true;
  }
}
